import { useState } from 'react';
import cn from 'classnames';
import { Skeleton } from '@round/ui-kit';
import { Tooltip } from '@round/whitelabel-ui';
import { getUserNameInitials } from '../../../User/user.helpers';
import styles from './PartnerClientAvatar.module.css';

type Props = {
    name: string;
    logo?: string | null;
    isLoading?: boolean;
    className?: string;
};

const PartnerClientAvatar = ({ name, logo, isLoading, className }: Props) => {
    const [anchor, setAnchor] = useState<HTMLSpanElement | null>(null);
    // Falls back to initials when the logo fails to load
    const [failedLogo, setFailedLogo] = useState<string | null>(null);
    const isLogoShown = !!logo && logo !== failedLogo;

    if (isLoading) {
        return (
            <span className={cn(styles.avatar, className)}>
                <Skeleton circle width="var(--size)" height="var(--size)" />
            </span>
        );
    }

    return (
        <>
            <span ref={setAnchor} role="img" aria-label={name} className={cn(styles.avatar, className)}>
                {isLogoShown ? (
                    <img src={logo} alt="" className={styles.logo} onError={() => setFailedLogo(logo)} />
                ) : (
                    getUserNameInitials(name)
                )}
            </span>
            <Tooltip anchorElement={anchor}>
                <Tooltip.Body>{name}</Tooltip.Body>
            </Tooltip>
        </>
    );
};

export default PartnerClientAvatar;
